import React from 'react';
import { InputRow } from '../../../helpers/uiComponents/InputRow';

class StepFour extends React.Component {
    render() {
        const data = this.props.data;
        return(
            <React.Fragment>
                <h4>4. Select the Email Event that you want to test</h4>
                <p><small>Can be found in the email events within the Promotions or Email Campaing tools. A disabled input field, containing a numeric ID that identifies each event.</small></p>
                <InputRow label="Email Event ID*" type="select" options={data} id="eventId" />
            </React.Fragment>
        )
    }
}
export default StepFour;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/TestSteps/StepFour.js